/**
 * The one loading state for whole screens: spinner + label, announced
 * politely, and invisible for the first moments (`.q-loading` fades in after
 * `--loading-delay`), so fast local reads never flash a spinner. Pair it with
 * useLoadingIndicator.
 *
 * Replaces five hand-made spinners, each with its own `@keyframes spin` in an
 * inline <style> — which only existed while that component was mounted and
 * overwrote the others (audit M5).
 */
export function LoadingState({ label, inline = false }: { label?: string | undefined; inline?: boolean }) {
  return (
    <div className={`q-loading${inline ? ' q-loading--inline' : ''}`} role="status">
      <span className="q-spinner" aria-hidden="true" />
      {label && <span className="q-loading-label">{label}</span>}
    </div>
  )
}
